import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, Carousel, Col, Row
} from 'antd';

/**
 * @description Define a Row
 * @param {columns} Array Columns to render
 * @param {index} Row  Row index
 * @param {gutter} Col Distance between columns in PX
 * @return <Row/>
 */
const row = (columns, index, gutter) => (
  <Row gutter={gutter} key={index}>{columns}</Row>
);
/**
 * @description Define a Column
 * @param {size} Number Size of the Item small/large
 * @param {item} Object  The data to render
 * @param {width} Number Width of the item
 * @param {renderer} Function Render the item
 * @param {extra} Function Extra information to diaplsy
 * @return <Col/>
 */
const col = (size, item, width, renderer, extra, title) => (
  <Col key={item.key} span={width}>
    <Card size={size} extra={extra(item)} title={title(item)}>{renderer(item)}</Card>
  </Col>
);

const Slider = ({
  afterChange,
  autoplay,
  beforeChange,
  cardSize,
  columns,
  columnWidth,
  dotPosition,
  dots,
  easing,
  effect,
  extra,
  title,
  gutter,
  itemRenderer,
  items,
  style
}) => {
  const children = [];
  const cols = [];
  // iterate through each item and build the Rows and Cols
  items.forEach((item, index) => {
    const columnIndex = index + 1; // start from 1
    // add a column
    cols.push(col(cardSize, item, columnWidth, itemRenderer, extra, title));
    if (!(columnIndex % columns) || columnIndex === items.length) {
      // add a row and its columns
      children.push(row(cols.slice(0), columnIndex, gutter));
      cols.length = 0; // resets the columns
    }
  });
  return (
    <Carousel
      afterChange={afterChange}
      autoplay={autoplay}
      beforeChange={beforeChange}
      effect={effect}
      easing={easing}
      dotPosition={dotPosition}
      dots={dots}
      style={style}
    >
      {children}
    </Carousel>
  );
};

Slider.propTypes = {
  afterChange: PropTypes.func,
  autoplay: PropTypes.bool,
  beforeChange: PropTypes.func,
  cardSize: PropTypes.string,
  columnWidth: PropTypes.number,
  dotPosition: PropTypes.string,
  dots: PropTypes.bool,
  easing: PropTypes.string,
  effect: PropTypes.string,
  extra: PropTypes.func,
  title: PropTypes.func,
  columns: PropTypes.number,
  gutter: PropTypes.number,
  itemRenderer: PropTypes.func,
  items: PropTypes.array,
  style: PropTypes.object
};

Slider.defaultProps = {
  afterChange() {
  },
  autoplay: false,
  beforeChange() {
  },
  cardSize: 'small',
  columns: 4,
  columnWidth: 4,
  dotPosition: 'bottom',
  dots: true,
  easing: 'linear',
  effect: 'scrollx',
  extra() {
    return null;
  },
  title() {
    return null;
  },
  gutter: 16,
  itemRenderer() {
  },
  items: [],
  style: {}
};

export default Slider;
